// extracted by mini-css-extract-plugin
export default {"parameter":"eycLy","name":"cNweK","imageWrapper":"JNGIM","title":"dnLTn","description":"ey10s"};